import React from "react";
import { Button, Spinner } from "reactstrap";

interface BaseButtonProps {
  color?:
    | "primary"
    | "secondary"
    | "success"
    | "danger"
    | "info"
    | "warning"
    | "link"
    | "light";
  label?: string;
  type?: "button" | "reset" | "submit";
  children?: React.ReactNode;
  onClick?: () => void;
  disable?: boolean;
  className?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  size?: "sm" | "md" | "lg";
  loader?: boolean;
}

const BaseButton: React.FC<BaseButtonProps> = ({
  color,
  label,
  type,
  onClick,
  disable,
  className,
  startIcon,
  endIcon,
  size,
  loader,
  children,
}) => {
  return (
    <div>
      <Button
        color={color}
        type={type}
        onClick={onClick}
        disabled={disable || loader}
        className={className}
        size={size}
      >
        {loader && <Spinner size="sm" className="me-2" />}
        {startIcon && <span className="me-2">{startIcon}</span>}
        {loader ? "Loading..." : label || children}
        {endIcon && <span className="ms-2">{endIcon}</span>}
      </Button>
    </div>
  );
};

export default BaseButton;
